// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { CSSObject } from 'styled-components';

export interface PaddingProps {
  padding?: string | number;
  paddingTop?: string | number;
  paddingRight?: string | number;
  paddingBottom?: string | number;
  paddingLeft?: string | number;
}

export default ({ padding, paddingTop, paddingRight, paddingBottom, paddingLeft }: PaddingProps) => {
  if (padding) {
    return { padding: typeof padding === 'number' ? `${padding}px` : padding }
  }

  const paddingStyle: CSSObject = { };

  if (paddingTop) {
    paddingStyle.paddingTop = typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop;
  }

  if (paddingRight) {
    paddingStyle.paddingRight = typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight;
  }

  if (paddingBottom) {
    paddingStyle.paddingBottom = typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom;
  }

  if (paddingLeft) {
    paddingStyle.paddingLeft = typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft;
  }

  return paddingStyle;
}
